import React, { useEffect, useState, useRef } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import ManageBookingItem from "../../../components/OrderManagement/ManageBookingItem";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import {
  setSections,
  setPageNext,
  setPagePrev,
} from "../../../redux/booking/booking-slice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
} from "@fortawesome/fontawesome-free-solid";
import { setProfileBoxAction } from "../../../redux/auth/auth-slice";
import Footer from "../../../components/footer/Footer";

const OrderManagement = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const {
    bookings,
    pageCount,
    totalBookingCount,
    bookingsLoading,
    upcomingBooking,
    upcomingBookingLength,
    jobsForTodayLength,
    jobsForToday,
    jobsForTomorrowLength,
    jobsForTomorrow,
    sections,
    filteredBookings,
    filteredBookingsNumber,
    filteredNotFound,
    isSearch,
    notFound,
  } = useSelector((state) => state.booking);

  useEffect(() => {
    if (token) {
      dispatch({
        type: "BOOKING_ASSIGNED",
        payload: {
          token: token,
          pageNumber: pageCount,
        },
      });
    }
  }, [pageCount, token]);

  // console.log("profileBoxAction ordermanagement",profileBoxAction)
  useEffect(() => {
    dispatch(setProfileBoxAction({ profileBoxAction: false }));
  }, []);

  return (
    <div className="fixed ">
      {/* header */}
      <Navbar />
      <div className="bg-black">
        <div
          className="relative mx-0"
          onClick={() => {
            dispatch(setProfileBoxAction({ profileBoxAction: false }));
          }}
        >
          {/* <div
            role="tablist"
            className="flex space-x-10 justify-center text-base mx-auto py-5"
          >
            <div
              onClick={() => {
                settabs({
                  tab1: true,
                  tab2: false,
                  tab3: false,
                  tab4: false,
                });
              }}
            >
              <div
                onClick={() => {
                  dispatch(
                    setSections({
                      allBooking: true,
                      upcomingBooking: false,
                      jobsForToday: false,
                      jobsForTomorrow: false,
                    })
                  );
                }}
                className={`transform transition-transform ${
                  tabs.tab1 ? "" : "text-base "
                } cursor-pointer text-white`}
              >
                All Bookings {totalBookingCount}
              </div>
              <div
                className={` transform ${
                  tabs.tab1
                    ? "translate-x-0 border-b-2 border-blue-500 shadow-blue-500 pt-1.5"
                    : "translate-x-10"
                } transition-transform duration-200 cursor-pointer`}
              />
            </div>
            <div
              onClick={() => {
                settabs({
                  tab1: false,
                  tab2: true,
                  tab3: false,
                  tab4: false,
                });
              }}
              className="relative w-max"
            >
              <div
                onClick={() => {
                  dispatch(
                    setSections({
                      allBooking: false,
                      upcomingBooking: true,
                      jobsForToday: false,
                      jobsForTomorrow: false,
                    })
                  );
                }}
                className="text-white cursor-pointer"
              >
                Upcoming Bookings {upcomingBookingLength}
              </div>
              <div
                className={` transform ${
                  tabs.tab2
                    ? "translate-x-0 border-b-2 border-blue-500 pt-1.5"
                    : (!tabs.tab1 && !tabs.tab3) || (!tabs.tab2 && !tabs.tab1)
                      ? "translate-x-10"
                      : "-translate-x-10"
                } transition-transform duration-200`}
              />
            </div>
            <div
              onClick={() => {
                settabs({
                  tab1: false,
                  tab2: false,
                  tab3: true,
                  tab4: false,
                });
              }}
              className="relative w-max"
            >
              <div
                onClick={() => {
                  dispatch(
                    setSections({
                      allBooking: false,
                      upcomingBooking: false,
                      jobsForToday: true,
                      jobsForTomorrow: false,
                    })
                  );
                }}
                className="text-white cursor-pointer"
              >
                Jobs for today {jobsForTodayLength}
              </div>
              <div
                className={` transform ${
                  tabs.tab3
                    ? "translate-x-0 border-b-2 border-blue-500 pt-1.5"
                    : !tabs.tab1 && !tabs.tab2
                      ? "translate-x-10"
                      : "-translate-x-10"
                } transition-transform duration-200`}
              />
            </div>
            <div
              onClick={() => {
                settabs({
                  tab1: false,
                  tab2: false,
                  tab3: false,
                  tab4: true,
                });
              }}
              className="relative w-max"
            >
              <div
                onClick={() => {
                  dispatch(
                    setSections({
                      allBooking: false,
                      upcomingBooking: false,
                      jobsForToday: false,
                      jobsForTomorrow: true,
                    })
                  );
                }}
                className="text-white cursor-pointer"
              >
                Jobs for tomorrow {jobsForTomorrowLength}
              </div>
              <div
                className={` transform 
                ${
                  tabs.tab4
                    ? "translate-x-0 border-b-2 border-blue-500 pt-1.5"
                    : "-translate-x-10 "
                } 
                 transition-transform duration-200`}
                // className={` translate-x-0 transform border-b-2 border-white
                // transition-transform duration-200
                // `}
              />
            </div>
          </div> */}

          {/* ***************test */}

          {/* <div className="sm:hidden flex h-8 justify-end 2md:justify-start xl:justify-center sm:space-x-7 lg:space-x-10 xl:space-x-6 2xl:space-x-10 space-x-0 -space-y-2 sm:space-y-0 px-3 md:px-10 py-2 2xl:px-80 mt-6 mb-6 mr-4 sm:mt-0 md:mt-0 sm:mb-4 2md:mb-0 sm:pt-16 md:pt-6">
            <div className="select-container w-52 h-8 text-[15px] bg-white rounded-md">
              <ReactSelect
                menuPosition="fixed"
                options={options}
                menuPlacement="auto"
              />
            </div>
          </div> */}
        </div>
        <div
          className="mt-5 sm:mt-0 bg-black h-[88vh] grid grid-cols-1 w-full gap-y-5 gap-x-10 px-3 sm:px-10 md:px-10 xl:px-16 2xl:px-32 overflow-y-auto overflow-x-hidden scrollbar fixed pt-2 sm:pt-5 pb-28"
          onClick={() => {
            dispatch(setProfileBoxAction({ profileBoxAction: false }));
          }}
        >
          {bookingsLoading ? (
            <>
              <div class="flex justify-center items-center h-screen bg-black">
                <div class="loader">
                  <div class="inner one"></div>
                  <div class="inner two"></div>
                  <div class="inner three"></div>
                </div>
              </div>
            </>
          ) : (
            <>
              {isSearch && notFound && (
                <div className="mt-[78px] mx-auto flex flex-col items-center">
                  <div>
                    <svg
                      width="446"
                      height="353"
                      viewBox="0 0 446 353"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_68_671)">
                        <path
                          d="M349.529 83.667H347.584V30.6719C347.584 22.5372 344.329 14.7357 338.536 8.9836C332.743 3.2315 324.886 4.00099e-09 316.693 4.00099e-09H203.613C199.556 -6.50518e-05 195.539 0.793224 191.791 2.33457C188.044 3.87592 184.638 6.13514 181.77 8.98325C178.901 11.8314 176.626 15.2126 175.073 18.9338C173.521 22.6551 172.722 26.6435 172.722 30.6714V321.407C172.722 329.541 175.976 337.343 181.769 343.095C187.562 348.847 195.42 352.079 203.612 352.079H316.692C324.884 352.079 332.741 348.847 338.535 343.095C344.328 337.343 347.582 329.541 347.582 321.407V121.39H349.528L349.529 83.667Z"
                          fill="#3F3D56"
                        />
                        <path
                          d="M341.248 28.6178V323.46C341.247 329.628 338.779 335.543 334.387 339.904C329.995 344.266 324.039 346.718 317.827 346.72H202.427C196.213 346.721 190.253 344.271 185.858 339.909C181.463 335.547 178.993 329.63 178.991 323.46V28.6178C178.993 22.448 181.463 16.5316 185.858 12.1698C190.253 7.80802 196.212 5.3581 202.426 5.35889H216.425C215.737 7.03726 215.476 8.85758 215.663 10.6599C215.85 12.4621 216.48 14.1912 217.498 15.695C218.515 17.1989 219.89 18.4315 221.5 19.2845C223.109 20.1375 224.906 20.5848 226.73 20.5871H292.522C294.347 20.5848 296.143 20.1375 297.753 19.2845C299.363 18.4315 300.737 17.1989 301.755 15.695C302.772 14.1912 303.402 12.4621 303.59 10.6599C303.777 8.85758 303.515 7.03726 302.828 5.35889H317.823C324.034 5.35994 329.991 7.81015 334.384 12.1709C338.776 16.5316 341.245 22.4458 341.248 28.6134V28.6178Z"
                          fill="#1A1A1C"
                        />
                        <path
                          d="M260.098 146.978C286.706 146.978 308.276 125.561 308.276 99.1413C308.276 72.7216 286.706 51.3042 260.098 51.3042C233.49 51.3042 211.92 72.7216 211.92 99.1413C211.92 125.561 233.49 146.978 260.098 146.978Z"
                          fill="#2B2A3E"
                        />
                        <path
                          d="M312.643 198.451H210.096C209.593 198.45 209.11 198.251 208.754 197.898C208.398 197.544 208.198 197.065 208.197 196.565V171.308C208.198 170.808 208.398 170.329 208.754 169.976C209.11 169.622 209.593 169.424 210.096 169.423H312.643C313.146 169.424 313.629 169.622 313.985 169.976C314.341 170.329 314.541 170.808 314.542 171.308V196.566C314.541 197.065 314.341 197.545 313.985 197.898C313.629 198.252 313.146 198.45 312.643 198.451V198.451ZM210.096 170.177C209.794 170.177 209.504 170.296 209.291 170.509C209.077 170.721 208.957 171.008 208.957 171.308V196.566C208.957 196.866 209.077 197.153 209.291 197.365C209.504 197.578 209.794 197.697 210.096 197.697H312.643C312.945 197.697 313.235 197.578 313.448 197.365C313.662 197.153 313.782 196.866 313.782 196.566V171.308C313.782 171.008 313.662 170.721 313.448 170.509C313.235 170.296 312.945 170.177 312.643 170.177H210.096Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M241.809 178.519C241.456 178.519 241.118 178.658 240.869 178.905C240.62 179.153 240.479 179.488 240.479 179.839C240.479 180.189 240.62 180.524 240.869 180.772C241.118 181.019 241.456 181.158 241.809 181.158H304.476C304.828 181.172 305.171 181.046 305.43 180.808C305.689 180.57 305.842 180.24 305.855 179.89C305.869 179.54 305.742 179.199 305.502 178.942C305.262 178.685 304.93 178.533 304.578 178.52C304.558 178.519 304.539 178.519 304.519 178.519L241.809 178.519Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M241.809 186.437C241.456 186.437 241.118 186.576 240.869 186.823C240.62 187.071 240.479 187.406 240.479 187.756C240.479 188.107 240.62 188.442 240.869 188.69C241.118 188.937 241.456 189.076 241.809 189.076H304.476C304.828 189.09 305.171 188.964 305.43 188.726C305.689 188.488 305.842 188.158 305.855 187.808C305.869 187.458 305.742 187.117 305.502 186.86C305.262 186.603 304.93 186.451 304.578 186.438C304.558 186.437 304.539 186.437 304.519 186.437L241.809 186.437Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M312.643 240.548H210.096C209.593 240.548 209.11 240.349 208.754 239.995C208.398 239.642 208.198 239.163 208.197 238.663V213.406C208.198 212.906 208.398 212.427 208.754 212.073C209.11 211.72 209.593 211.521 210.096 211.521H312.643C313.146 211.521 313.629 211.72 313.985 212.073C314.341 212.427 314.541 212.906 314.542 213.406V238.663C314.541 239.163 314.34 239.642 313.985 239.995C313.629 240.349 313.146 240.548 312.643 240.548ZM210.096 212.274C209.794 212.275 209.504 212.394 209.291 212.606C209.077 212.818 208.957 213.106 208.957 213.406V238.663C208.957 238.963 209.077 239.251 209.291 239.463C209.504 239.675 209.794 239.795 210.096 239.795H312.643C312.945 239.795 313.235 239.675 313.448 239.463C313.662 239.251 313.782 238.963 313.782 238.663V213.406C313.782 213.106 313.662 212.818 313.448 212.606C313.235 212.394 312.945 212.275 312.643 212.274H210.096Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M241.809 220.753C241.456 220.753 241.118 220.892 240.869 221.14C240.62 221.387 240.479 221.723 240.479 222.073C240.479 222.423 240.62 222.759 240.869 223.006C241.118 223.254 241.456 223.393 241.809 223.393H304.476C304.823 223.391 305.156 223.254 305.403 223.011C305.65 222.768 305.792 222.439 305.798 222.094C305.803 221.749 305.673 221.416 305.434 221.165C305.195 220.914 304.866 220.767 304.519 220.753H241.809V220.753Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M241.809 228.673C241.456 228.673 241.118 228.812 240.869 229.06C240.62 229.308 240.479 229.643 240.479 229.993C240.479 230.343 240.62 230.679 240.869 230.927C241.118 231.174 241.456 231.313 241.809 231.313H304.476C304.823 231.311 305.156 231.174 305.403 230.932C305.65 230.689 305.792 230.36 305.798 230.015C305.803 229.67 305.673 229.336 305.434 229.085C305.195 228.835 304.866 228.687 304.519 228.674H241.809V228.673Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M312.643 282.784H210.096C209.593 282.784 209.11 282.585 208.754 282.231C208.398 281.878 208.198 281.399 208.197 280.899V255.642C208.198 255.142 208.398 254.663 208.754 254.309C209.11 253.956 209.593 253.757 210.096 253.756H312.643C313.146 253.757 313.629 253.956 313.985 254.309C314.341 254.663 314.541 255.142 314.542 255.642V280.899C314.541 281.399 314.341 281.878 313.985 282.232C313.629 282.585 313.146 282.784 312.643 282.785V282.784ZM210.096 254.51C209.794 254.511 209.504 254.63 209.291 254.842C209.077 255.054 208.957 255.342 208.957 255.642V280.899C208.957 281.199 209.077 281.487 209.291 281.699C209.504 281.911 209.794 282.03 210.096 282.031H312.643C312.945 282.03 313.235 281.911 313.448 281.699C313.662 281.487 313.782 281.199 313.782 280.899V255.642C313.782 255.342 313.662 255.054 313.448 254.842C313.235 254.63 312.945 254.511 312.643 254.51H210.096Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M241.809 262.99C241.456 262.99 241.118 263.129 240.869 263.377C240.62 263.624 240.479 263.96 240.479 264.31C240.479 264.66 240.62 264.996 240.869 265.244C241.118 265.491 241.456 265.63 241.809 265.63H304.476C304.65 265.637 304.824 265.609 304.988 265.549C305.152 265.489 305.302 265.397 305.43 265.279C305.558 265.162 305.662 265.02 305.735 264.862C305.808 264.705 305.849 264.535 305.855 264.361C305.862 264.188 305.834 264.015 305.774 263.853C305.713 263.69 305.621 263.541 305.502 263.414C305.383 263.287 305.241 263.184 305.082 263.111C304.923 263.039 304.752 262.998 304.578 262.992C304.558 262.991 304.539 262.991 304.519 262.991L241.809 262.99Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M241.809 270.91C241.456 270.91 241.118 271.049 240.869 271.297C240.62 271.544 240.479 271.88 240.479 272.23C240.479 272.58 240.62 272.916 240.869 273.163C241.118 273.411 241.456 273.55 241.809 273.55H304.476C304.65 273.557 304.824 273.529 304.988 273.469C305.152 273.409 305.302 273.317 305.43 273.199C305.558 273.082 305.662 272.94 305.735 272.782C305.808 272.625 305.849 272.455 305.855 272.281C305.862 272.108 305.834 271.935 305.774 271.773C305.713 271.61 305.621 271.461 305.502 271.334C305.383 271.207 305.241 271.104 305.082 271.031C304.923 270.959 304.752 270.918 304.578 270.912C304.558 270.911 304.539 270.911 304.519 270.911H241.809L241.809 270.91Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M535.074 351.112H-89.0741C-89.9792 351.112 -90.7119 351.535 -90.7119 352.056C-90.7119 352.577 -89.9784 353 -89.0741 353H535.074C535.978 353 536.712 352.577 536.712 352.056C536.712 351.535 535.979 351.112 535.074 351.112Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M391.631 332.805C390.057 333.355 388.367 333.492 386.724 333.205C385.08 332.917 383.539 332.215 382.249 331.164C378.962 328.425 377.932 323.913 377.094 319.735L374.614 307.378L379.806 310.927C383.539 313.48 387.356 316.114 389.942 319.811C392.527 323.508 393.655 328.555 391.578 332.556"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M390.829 348.627C391.483 343.9 392.155 339.112 391.696 334.335C391.289 330.092 389.985 325.948 387.331 322.55C385.922 320.75 384.208 319.208 382.266 317.993C381.759 317.675 381.293 318.472 381.797 318.788C385.158 320.898 387.758 324.013 389.221 327.684C390.838 331.766 391.097 336.216 390.818 340.552C390.649 343.175 390.293 345.78 389.933 348.382C389.905 348.5 389.922 348.624 389.983 348.729C390.043 348.834 390.141 348.912 390.257 348.949C390.376 348.98 390.502 348.964 390.609 348.904C390.716 348.844 390.795 348.744 390.828 348.627H390.829Z"
                          fill="#F2F2F2"
                        />
                        <path
                          d="M386.126 341.042C385.451 342.061 384.523 342.89 383.431 343.449C382.34 344.009 381.122 344.28 379.894 344.236C376.739 344.087 374.109 341.901 371.742 339.827L364.739 333.686L369.374 333.466C372.707 333.308 376.126 333.16 379.302 334.181C382.479 335.201 385.405 337.657 385.985 340.918"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M392.676 351.344C389.533 345.817 385.882 339.675 379.362 337.711C377.549 337.167 375.649 336.973 373.762 337.137C373.168 337.187 373.316 338.098 373.912 338.047C377.074 337.787 380.23 338.616 382.849 340.395C385.369 342.098 387.33 344.466 388.991 346.977C390.008 348.512 390.919 350.118 391.83 351.719C392.12 352.23 392.971 351.861 392.676 351.344Z"
                          fill="#F2F2F2"
                        />
                        <path
                          d="M222.889 191.701C227.294 191.701 230.865 188.155 230.865 183.782C230.865 179.408 227.294 175.862 222.889 175.862C218.484 175.862 214.913 179.408 214.913 183.782C214.913 188.155 218.484 191.701 222.889 191.701Z"
                          fill="#C3C1DF"
                        />
                        <path
                          d="M219.07 182.302C218.979 182.302 218.904 182.893 218.904 183.622C218.904 184.351 218.979 184.942 219.07 184.942H226.913C227.005 184.954 227.081 184.373 227.082 183.644C227.133 183.191 227.077 182.731 226.918 182.303H219.07V182.302Z"
                          fill="#2A2A40"
                        />
                        <path
                          d="M222.889 233.954C227.294 233.954 230.865 230.408 230.865 226.035C230.865 221.661 227.294 218.115 222.889 218.115C218.484 218.115 214.913 221.661 214.913 226.035C214.913 230.408 218.484 233.954 222.889 233.954Z"
                          fill="#C3C1DF"
                        />
                        <path
                          d="M219.07 224.555C218.979 224.555 218.904 225.146 218.904 225.875C218.904 226.604 218.979 227.195 219.07 227.195H226.913C227.005 227.207 227.081 226.626 227.082 225.897C227.133 225.443 227.077 224.984 226.918 224.556L219.07 224.555Z"
                          fill="#2A2A40"
                        />
                        <path
                          d="M222.889 276.19C227.294 276.19 230.865 272.644 230.865 268.27C230.865 263.897 227.294 260.351 222.889 260.351C218.484 260.351 214.913 263.897 214.913 268.27C214.913 272.644 218.484 276.19 222.889 276.19Z"
                          fill="#C3C1DF"
                        />
                        <path
                          d="M219.07 266.791C218.979 266.791 218.904 267.382 218.904 268.111C218.904 268.839 218.979 269.431 219.07 269.431H226.913C227.005 269.443 227.081 268.862 227.082 268.133C227.133 267.679 227.077 267.22 226.918 266.791L219.07 266.791Z"
                          fill="#2A2A40"
                        />
                        <path
                          d="M249.69 86.0058L246.868 88.8081L270.505 112.278L273.327 109.475L249.69 86.0058Z"
                          fill="white"
                        />
                        <path
                          d="M273.327 88.8077L270.505 86.0054L246.868 109.475L249.69 112.277L273.327 88.8077Z"
                          fill="white"
                        />
                        <path
                          d="M82.8283 225.964C83.5197 225.721 84.1491 225.33 84.6721 224.82C85.195 224.309 85.5989 223.691 85.8551 223.008C86.1114 222.326 86.2139 221.596 86.1554 220.87C86.0969 220.144 85.8787 219.44 85.5164 218.807L97.2735 205.499L88.0957 204.242L78.3379 217.072C77.307 217.747 76.5612 218.774 76.2419 219.958C75.9226 221.143 76.0519 222.402 76.6054 223.498C77.1589 224.594 78.0981 225.451 79.245 225.905C80.3919 226.36 81.6669 226.38 82.8283 225.964Z"
                          fill="#EEA7B1"
                        />
                        <path
                          d="M97.008 343.906L88.8083 343.905L84.9072 312.5L97.0095 312.501L97.008 343.906Z"
                          fill="#EEA7B1"
                        />
                        <path
                          d="M99.0993 351.798L72.6592 351.797V351.465C72.6594 348.755 73.7437 346.156 75.6736 344.24C77.6036 342.324 80.2211 341.247 82.9504 341.247H82.9511L99.0998 341.248L99.0993 351.798Z"
                          fill="#2F2E41"
                        />
                        <path
                          d="M139.932 337.092L132.101 339.506L118.996 310.662L130.554 307.1L139.932 337.092Z"
                          fill="#EEA7B1"
                        />
                        <path
                          d="M144.287 344.014L119.036 351.798L118.936 351.481C118.127 348.893 118.387 346.091 119.657 343.693C120.928 341.295 123.106 339.496 125.713 338.692L125.714 338.692L141.136 333.938L144.287 344.014Z"
                          fill="#2F2E41"
                        />
                        <path
                          d="M90.7283 199.118L78.584 212.928L88.0915 213.777L90.7283 199.118Z"
                          fill="#C8C8C8"
                        />
                        <path
                          d="M85.9837 216.918C85.9837 216.918 81.7653 219.012 81.238 228.437C80.7106 237.861 82.82 262.47 82.82 262.47C82.82 262.47 80.7111 273.464 82.82 283.412C84.929 293.359 80.7111 329.483 83.3474 329.483C85.9837 329.483 99.693 331.054 100.22 329.483C100.748 327.912 101.275 304.352 101.275 304.352C101.275 304.352 105.493 292.311 101.275 284.983C101.275 284.983 116.004 310.519 125.53 330.008C127.615 334.273 143.458 329.484 140.821 324.772C138.185 320.06 131.858 298.595 131.858 298.595C131.858 298.595 127.112 282.888 118.676 276.082L122.894 242.574C122.894 242.574 131.858 220.061 126.586 216.92C121.314 213.779 85.9837 216.918 85.9837 216.918Z"
                          fill="#2F2E41"
                        />
                        <path
                          d="M101.801 131.579C109.373 131.579 115.51 125.484 115.51 117.966C115.51 110.448 109.373 104.354 101.801 104.354C94.2297 104.354 88.0918 110.448 88.0918 117.966C88.0918 125.484 94.2297 131.579 101.801 131.579Z"
                          fill="#D6A5AC"
                        />
                        <path
                          d="M117.093 132.625L100.05 142.573C100.05 142.573 93.5242 146.222 91.0864 152.52C88.4881 159.233 89.9983 168.684 91.0864 170.845C93.1954 175.033 90.2019 185.504 90.2019 185.504L87.5656 209.587C87.5656 209.587 78.0746 218.488 85.4566 219.535C92.8386 220.582 106.021 219.011 113.93 219.535C121.839 220.058 130.803 221.106 128.167 215.869C125.53 210.632 122.367 206.968 125.53 196.499C128.006 188.306 127.899 157.669 127.735 144.731C127.713 142.955 127.233 141.213 126.341 139.673C125.449 138.132 124.175 136.843 122.641 135.93L117.093 132.625Z"
                          fill="#C4C4C4"
                        />
                        <path
                          opacity="0.1"
                          d="M109.45 149.118L111.031 181.055L95.7014 211.879L93.1016 210.897L108.92 182.102L109.45 149.118Z"
                          fill="black"
                        />
                        <path
                          opacity="0.1"
                          d="M126.848 187.861V184.195L108.922 213.515L126.848 187.861Z"
                          fill="black"
                        />
                        <path
                          d="M92.0717 105.356L89.8071 104.456C89.8071 104.456 94.5469 99.2761 101.139 99.7264L99.2846 97.6992C99.2846 97.6992 103.817 95.8975 107.938 100.627C110.105 103.113 112.611 106.036 114.175 109.328H116.602L115.589 111.543L119.135 113.758L115.496 113.361C115.84 115.274 115.722 117.24 115.151 119.098L115.251 120.848C115.251 120.848 111.031 114.364 111.031 113.464V115.717C111.031 115.717 108.764 113.69 108.764 112.338L107.528 113.915L106.91 111.438L99.2861 113.915L100.521 111.887L95.7817 112.563L97.6362 110.086C97.6362 110.086 92.2793 113.014 92.0732 115.492C91.8672 117.97 89.189 121.122 89.189 121.122L87.9526 118.87C87.9526 118.87 86.0986 108.734 92.0717 105.356Z"
                          fill="#2F2E41"
                        />
                        <path
                          d="M100.941 227.445C101.578 227.084 102.128 226.589 102.551 225.994C102.974 225.4 103.261 224.72 103.391 224.003C103.522 223.287 103.492 222.55 103.305 221.846C103.117 221.142 102.777 220.487 102.307 219.928L111.498 204.759L102.241 205.14L94.9323 219.486C94.0384 220.332 93.4881 221.474 93.3856 222.696C93.2831 223.918 93.6355 225.134 94.3762 226.115C95.1168 227.097 96.1942 227.774 97.4041 228.019C98.6141 228.264 99.8725 228.06 100.941 227.445Z"
                          fill="#EEA7B1"
                        />
                        <path
                          d="M121.839 139.433L125.794 138.647C125.794 138.647 137.658 147.286 133.967 164.563C130.276 181.84 113.93 208.018 113.93 208.018C113.93 208.018 110.238 212.73 109.184 213.777C108.131 214.824 106.021 213.777 107.075 215.348C108.13 216.919 105.493 217.965 105.493 217.965C105.493 217.965 93.893 217.965 94.9477 213.777C96.0024 209.588 113.93 179.744 113.93 179.744L111.294 151.996C111.294 151.996 109.184 138.385 121.839 139.433Z"
                          fill="#C4C4C4"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_68_671">
                          <rect width="446" height="353" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="text-[48px] text-center font-bold leading-[1.5]">
                    Search Result Not found
                  </div>
                </div>
              )}
              {isSearch &&
                !notFound &&
                filteredBookings?.map((booking) => (
                  <ManageBookingItem
                    bookingId={booking?.bookingId}
                    Bookingtype={booking?.bookingType}
                    pickupLocation={booking?.source?.placename}
                    dropofLocation={booking?.destination?.placename}
                    travelDate={booking?.travelDate}
                    travelTime={booking?.travelTime}
                    amount={booking?.purchasePrice}
                    currency={booking?.purchaseCurrency}
                    vehicletype={booking?.vehicleDetails?.categoryType}
                    bookingStatus={booking?.bookingStatus}
                    duration={
                      booking?.durationForAffiliate
                        ? booking?.durationForAffiliate + " hours"
                        : booking?.duration
                    }
                    spreq={booking?.passengerDetails?.specialRequest}
                    travelDistance={booking?.travelDistance}
                    driverName={
                      booking?.driverDetails
                        ? booking?.driverDetails?.name
                        : "Driver not assigned!"
                    }
                    driverContact={
                      booking?.driverDetails
                        ? booking?.driverDetails?.contactNumber
                        : "No contact found!"
                    }
                    driverCountryCode={
                      booking?.driverDetails
                        ? booking?.driverDetails?.countryCode
                        : ""
                    }
                    affiliateNote={booking?.affiliateNote}
                  />
                ))}

              {sections?.allBooking &&
                !isSearch &&
                bookings.map((booking) => (
                  <div key={booking?._id}>
                    <ManageBookingItem
                      bookingId={booking?.bookingId}
                      Bookingtype={booking?.bookingType}
                      pickupLocation={booking?.source?.placename}
                      dropofLocation={booking?.destination?.placename}
                      travelDate={booking?.travelDate}
                      travelTime={booking?.travelTime}
                      amount={booking?.purchasePrice}
                      currency={booking?.purchaseCurrency}
                      vehicletype={booking?.vehicleDetails?.categoryType}
                      bookingStatus={booking?.bookingStatus}
                      duration={
                        booking?.durationForAffiliate
                          ? booking?.durationForAffiliate + " hours"
                          : booking?.duration
                      }
                      spreq={booking?.passengerDetails?.specialRequest}
                      travelDistance={booking?.travelDistance}
                      driverName={
                        booking?.driverDetails
                          ? booking?.driverDetails?.name
                          : "Driver not assigned!"
                      }
                      driverContact={
                        booking?.driverDetails
                          ? booking?.driverDetails?.contactNumber
                          : "No contact found!"
                      }
                      driverCountryCode={
                        booking?.driverDetails
                          ? booking?.driverDetails?.countryCode
                          : ""
                      }
                      affiliateNote={booking?.affiliateNote}
                    />
                  </div>
                ))}

              {sections?.upcomingBooking &&
                !isSearch &&
                upcomingBooking.map((booking) => (
                  <>
                    <div key={booking?._id}>
                      <ManageBookingItem
                        bookingId={booking?.bookingId}
                        Bookingtype={booking?.bookingType}
                        pickupLocation={booking?.source?.placename}
                        dropofLocation={booking?.destination?.placename}
                        travelDate={booking?.travelDate}
                        travelTime={booking?.travelTime}
                        amount={booking?.purchasePrice}
                        currency={booking?.purchaseCurrency}
                        vehicletype={booking?.vehicleDetails?.categoryType}
                        bookingStatus={booking?.bookingStatus}
                        duration={
                          booking?.durationForAffiliate
                            ? booking?.durationForAffiliate + " hours"
                            : booking?.duration
                        }
                        spreq={booking?.passengerDetails?.specialRequest}
                        travelDistance={booking?.travelDistance}
                      />
                    </div>
                  </>
                ))}

              {sections?.jobsForToday &&
                !isSearch &&
                jobsForToday.map((booking) => (
                  <>
                    <div key={booking?._id}>
                      <ManageBookingItem
                        bookingId={booking?.bookingId}
                        Bookingtype={booking?.bookingType}
                        pickupLocation={booking?.source?.placename}
                        dropofLocation={booking?.destination?.placename}
                        travelDate={booking?.travelDate}
                        travelTime={booking?.travelTime}
                        amount={booking?.purchasePrice}
                        currency={booking?.purchaseCurrency}
                        vehicletype={booking?.vehicleDetails?.categoryType}
                        bookingStatus={booking?.bookingStatus}
                        duration={
                          booking?.durationForAffiliate
                            ? booking?.durationForAffiliate + " hours"
                            : booking?.duration
                        }
                        spreq={booking?.passengerDetails?.specialRequest}
                        travelDistance={booking?.travelDistance}
                      />
                    </div>
                  </>
                ))}

              {sections?.jobsForTomorrow &&
                !isSearch &&
                jobsForTomorrow.map((booking) => (
                  <>
                    <div key={booking?._id}>
                      <ManageBookingItem
                        bookingId={booking?.bookingId}
                        Bookingtype={booking?.bookingType}
                        pickupLocation={booking?.source?.placename}
                        dropofLocation={booking?.destination?.placename}
                        travelDate={booking?.travelDate}
                        travelTime={booking?.travelTime}
                        amount={booking?.purchasePrice}
                        currency={booking?.purchaseCurrency}
                        vehicletype={booking?.vehicleDetails?.categoryType}
                        bookingStatus={booking?.bookingStatus}
                        duration={
                          booking?.durationForAffiliate
                            ? booking?.durationForAffiliate + " hours"
                            : booking?.duration
                        }
                        spreq={booking?.passengerDetails?.specialRequest}
                        travelDistance={booking?.travelDistance}
                      />
                    </div>
                  </>
                ))}
            </>
          )}

          <div className="">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderManagement;
